import { planUtils } from 'utils/plan/plan.utils';
import {
  activeRcpSubscriptionStatuses,
  deletingAaRcpStatuses,
  deletingRcpStatuses,
  rcpValidateProvisionStatuses
} from '../constants/subscription.constants';
import { getIsSubReserved } from './getIsSubReserved/getIsSubReserved';

export const isRcpClusterExists = (rcp: SubsRcp) => {
  return Boolean(rcp?.cluster?.url);
};

export const isSubFlexibleActive = (selectedSub: Subscription) => {
  if (!selectedSub.rcp) {
    return false;
  }

  return (
    activeRcpSubscriptionStatuses.includes(selectedSub.rcp.status) ||
    isRcpUpdateFailedOrTerminatedOnValidateProvision(selectedSub.rcp)
  );
};

export const isRcpUpdateFailedOrTerminatedOnValidateProvision = (rcp: SubsRcp) => {
  return rcpValidateProvisionStatuses.includes(rcp.status) && isRcpClusterExists(rcp);
};

export const isSubscriptionActive = (selectedSub: Subscription, plan: Plan) => {
  const planType = planUtils.getType(plan);

  if (planType === 'pro') {
    return isSubFlexibleActive(selectedSub);
  }

  if (planType === 'active-active') {
    return selectedSub.aa_rcp?.status === 'active';
  }

  return selectedSub.status === 'active';
};

export const isSubDeleting = (sub: Subscription) => {
  if (sub?.status === 'deleted') {
    return true;
  }

  if (sub?.rcp?.status && deletingRcpStatuses.includes(sub.rcp.status)) {
    return true;
  }

  if (sub?.aa_rcp?.status && deletingAaRcpStatuses.includes(sub.aa_rcp.status)) {
    return true;
  }

  return false;
};

export const getSubscriptionStatus = (subscription: Subscription, plan: Plan) => {
  const planType = planUtils.getType(plan);

  if (planType === 'active-active') {
    return getMappedAARcpStatus(subscription.aa_rcp?.status);
  }

  if (planType === 'pro') {
    return subscription.rcp ? getMappedRcpStatus(subscription.rcp.status) : subscription.status;
  }

  return subscription.status;
};

export const getMappedRcpStatus = (status: RcpStatus): RcpStatus => {
  if (status === 'optimization_draft' || status === 'optimization_pending') {
    return 'provision_pending';
  }

  return status;
};

export const getMappedAARcpStatus = (status: AARcpStatus): AARcpStatus => {
  if (status === 'optimization_pending') {
    return 'pending';
  }

  return status;
};

export const isSubscriptionReservedPending = (subscription: Subscription, plan: Plan) => {
  if (getIsSubReserved(subscription, plan)) {
    return subscription.status === 'pending';
  }

  return false;
};

export const isPendingTypeIcon = (status: SubIndicatorStatus) => {
  return status === 'encryption_key_pending' || status === 'encryption_key_revoked';
};

export const isSubscriptionProvisionError = (subscription: Subscription) => {
  if (!subscription.rcp) {
    return false;
  }

  return (
    subscription.rcp.status === 'provision_error' ||
    (subscription.rcp.status === 'validate_provision_error' &&
      !isRcpClusterExists(subscription.rcp))
  );
};
